module.exports = __webpack_public_path__ + "img/index-img-01.d704e84d.png";